import React, { useContext, useState } from 'react'
import { CartContext } from '../../context/CartContext'
import { useQuery } from 'react-query'
import Loading from '../Loading/Loading';
import { toast } from 'react-hot-toast'
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import { paths } from '../../utils/routes';



export default function Cart() {
  const { getLoggedInUserCart, deleteProductFromCart, updateProductCountInCart, emptyCart } = useContext(CartContext);
  const { isLoading, isError, data, refetch } = useQuery('cartItems', () => getLoggedInUserCart());
  const [isEmpty, setIsEmpty] = useState(null)
  const navigator = useNavigate();


  localStorage.setItem('userId', data?.data.cartOwner)


  const updataCount = async (productId, count) => {
    if (!count <= 0) {
      try {
        await updateProductCountInCart(productId, count);
        refetch()
      } catch (error) {
        toast.error(error)
      }
    }

  }
  const deleteItemFromCart = async (productId) => {
    try {
      await deleteProductFromCart(productId)
      refetch()
    } catch (error) {
    }
  }
  const getCartEmpty = async () => {
    try {
      await emptyCart()
      refetch()
    } catch (error) {
    }
  }

  return <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Cart</title>
    </Helmet>
    {isLoading && <Loading />}
    {data &&
      <div className="w-75 mx-auto p-3 bg-main-light">
        <div className="d-flex justify-content-between align-items center mb-3">
          <h3>Shopping Cart</h3>
          <div className="d-flex flex-column ">
            <button onClick={getCartEmpty} className='my-2 btn bg-danger text-light p-2'><i className='fas fa-trash-can px-2'></i>Empty Cart</button>
            <button onClick={() => navigator(paths.payment)} className='my-2 btn bg-main text-white p-2'><i className="fa-regular fa-credit-card px-2"></i>Pay Now!</button>
          </div>
        </div>
        <div className='my-3'>
          <h4 className=' fw-bolder text-main h6'>
            Cart Items: {data.numOfCartItems}
          </h4>
          <h4 className='h6 fw-bolder text-main'>Total Cart Price: {data.data.totalCartPrice} EGP </h4>
        </div>

        {data?.data.products.map(product => <div key={product.product.id} className="row border-bottom py-2" >
          <div className="col-md-1">
            <img className='w-100' src={product.product.imageCover} alt="" />
          </div>
          <div className="col-md-11">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h3 className='h6'>{product.product.title.split(' ').slice(0, 3).join(' ')}</h3>
                <h6 className='text-main'>Price: {product.price} EGP</h6>
              </div>
              <div > <button onClick={() => updataCount(product.product.id, product.count + 1)} className=' border-main p-1'>+</button>
                <span className='mx-2'>{product.count}</span>
                <button onClick={() => updataCount(product.product.id, product.count - 1)} className=' border-main p-1'>-</button>

              </div>

            </div>
            <button onClick={() => deleteItemFromCart(product.product.id)} className='btn p-0'> <i className='text-danger font-sm fas fa-trash-can'></i> remove</button>
          </div>
        </div>)}
      </div>

    }
    {isError &&
      <div className='d-flex justify-content-center align-items-center bg-light p-5 rounded-2 mx-3'>
        <p className='text-center'>Your Cart is Empty!</p>
      </div>
    }
  </>
}
